import humanizeDuration from "humanize-duration";

// From https://stackoverflow.com/questions/9461621/format-a-number-as-2-5k-if-a-thousand-or-more-otherwise-900
function _getNumberPostfix(number, precision = 3) {
  if (number < 1000) {
    return { scaled: number, postfix: "" };
  }

  var SI_POSTFIXES = ["", "k", "M", "G", "T", "P", "E", "Z", "Y"];

  // what tier? (determines SI symbol)
  var tier = (Math.log10(Math.abs(number)) / 3) | 0;

  // if zero, we don't need a suffix
  if (tier == 0) return number;

  // get postfix and determine scale
  var postfix = SI_POSTFIXES[tier];
  var scale = Math.pow(10, tier * 3);

  // scale the number
  var scaled = number / scale;

  // format number
  if (precision) scaled = scaled.toPrecision(precision) + "";
  else scaled = scaled + "";

  if (/\.0$/.test(scaled)) {
    scaled = scaled.substr(0, scaled.length - 2);
  }

  // Return
  return { scaled, postfix };
}

export function formatHashrate(float, precision = 3) {
  if (!float) {
    float = 0;
  }

  const postfix = _getNumberPostfix(float, precision);
  return `${postfix.scaled} ${postfix.postfix}H/s`;
}

export function formatRelativeDate(lastSubmissionString) {
  if (!lastSubmissionString) return "—";

  const elapsed = Date.now() - Date.parse(lastSubmissionString);
  return (
    humanizeDuration(elapsed, {
      round: true,
      largest: 1, // number of units to display
    }) + " ago"
  );
}

export function formatDuration(seconds) {
  return humanizeDuration(seconds * 1000, {
    round: true,
    largest: 1, // number of units to display
  });
}

export function formatPool(pool, withLabel = false) {
  if (!pool) return "";

  let label = "";
  if (withLabel) {
    label = ` — ${pool.name}`;
  }
  return `${pool.host}:${pool.port}${label}`;
}

export function deferSortingToController() {
  return 0;
}

export function toEngineeringNotation(
  number,
  { minExponent = 0, maxExponent = 15 }
) {
  let rawExponent = ((Math.log10(Math.abs(number)) / 3) | 0) * 3;
  let exponent = Math.min(maxExponent, Math.max(minExponent, rawExponent));
  let coefficient = number / Math.pow(10, exponent);
  return { exponent, coefficient };
}

// Get the default handle for a given name.
// Normalize accents into ASCII when possible, and otherwise
// remove characters that are not lowercase alphabetic, numbers
// or dashes, then split words and join them with dashes.
export function defaultHandle(name, allowFormat = false) {
  if (name === "") return "";
  let disallowed = allowFormat ? /[^a-z0-9-\s%]/g : /[^a-z0-9-\s]/g;
  return name
    .normalize("NFKD")
    .toLowerCase()
    .replace(/[\u0300-\u036F]/g, "")
    .replace(disallowed, "")
    .trim()
    .replace(/^-*/, "")
    .replace(/-*$/, "")
    .split(/\s+/)
    .join("-");
}

export function sleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

export function getBreakpoint() {
  // Get the media breakpoint of the window / device for conditional/responsive rendering & styling
  var width = window.innerWidth > 0 ? window.innerWidth : screen.width;
  var breakpoint = { xs: false, sm: false, md: false, lg: false };
  if (width <= 567) {
    breakpoint.xs = true;
  } else if (width <= 768) {
    breakpoint.sm = true;
  } else if (width <= 992) {
    breakpoint.md = true;
  } else {
    breakpoint.lg = true;
  }

  return breakpoint;
}
